import { Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TenantUsersApi } from '@buspro/web/apis';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzResultComponent } from 'ng-zorro-antd/result';
import { NzSpinComponent } from 'ng-zorro-antd/spin';

@Component({
  selector: 'tenant-verify-email-change',
  template: `
    <div class="verify-card max-w-md w-full rounded-lg shadow-lg p-8">
      @if (verificationState() === 'verifying') {
        <div class="text-center">
          <nz-spin [nzSize]="'large'"></nz-spin>
          <p class="verify-label mt-4 text-lg">Verifying email change...</p>
        </div>
      }

      @if (verificationState() === 'success') {
        <nz-result
          nzStatus="success"
          nzTitle="Email Changed Successfully!"
          nzSubTitle="Your email address has been updated. You can now log in with your new email."
        >
          <div nz-result-extra>
            <a nz-button nzType="primary" routerLink="/passport/login">
              Go to Login
            </a>
          </div>
        </nz-result>
      }

      @if (verificationState() === 'error') {
        <nz-result
          nzStatus="error"
          nzTitle="Verification Failed"
          [nzSubTitle]="errorMessage()"
        >
          <div nz-result-extra>
            <a nz-button routerLink="/passport/login">
              Go to Login
            </a>
          </div>
        </nz-result>
      }
    </div>
  `,
  styles: [
    `
    .verify-card {
      background-color: var(--page-card-bg, #ffffff);
      color: var(--card-text, #111827);
    }
    .verify-label {
      color: var(--card-text-secondary, #6b7280);
    }
  `,
  ],
  standalone: true,
  imports: [NzResultComponent, NzSpinComponent, NzButtonModule, RouterLink],
})
export class VerifyEmailChangeComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private tenantUsersApi = inject(TenantUsersApi);

  verificationState = signal<'verifying' | 'success' | 'error'>('verifying');
  errorMessage = signal<string>('');

  ngOnInit() {
    const token = this.route.snapshot.queryParams['token'];

    if (!token) {
      this.verificationState.set('error');
      this.errorMessage.set('Invalid verification link');
      return;
    }

    this.verifyEmailChange(token);
  }

  private verifyEmailChange(token: string) {
    this.tenantUsersApi.tenantUsersControllerVerifyEmailChange({ body: { token } }).subscribe({
      next: () => {
        this.verificationState.set('success');
      },
      error: (error) => {
        this.verificationState.set('error');
        this.errorMessage.set(error?.error?.message || 'Email verification failed');
      },
    });
  }
}
